import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { EmptyState, Loader } from "@/components/EmptyState";
import { Button } from "@/components/ui/button";
import { Bell, CheckCheck, ClipboardList, Handshake, CreditCard, ShieldCheck, Users, Circle } from "lucide-react";

const ICONS = { order: ClipboardList, partner: Handshake, subscription: CreditCard, registration: ShieldCheck, operator: Users, account: ShieldCheck, welcome: Bell };

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => { const r = await api.get("/notifications"); setItems(r.data.notifications); setLoading(false); };
  useEffect(() => { load(); }, []);

  const readOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  const readAll = async () => { await api.post("/notifications/read-all"); toast.success("All marked as read"); load(); };

  if (loading) return <Loader />;

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl font-extrabold text-stone-900 sm:text-3xl">Notifications</h1>
          <p className="mt-1 text-stone-500">Business and platform updates.</p>
        </div>
        {items.some((n) => !n.read) && <Button variant="outline" data-testid="mark-all-read-btn" onClick={readAll}><CheckCheck className="mr-1 h-4 w-4" /> Mark all read</Button>}
      </div>

      {items.length === 0 ? (
        <EmptyState icon={Bell} title="No notifications" description="You're all caught up." testid="notifications-empty" />
      ) : (
        <div className="space-y-2">
          {items.map((n) => {
            const Icon = ICONS[n.type] || Bell;
            return (
              <button key={n.id} onClick={() => !n.read && readOne(n.id)} data-testid={`notification-${n.id}`}
                className={`flex w-full items-start gap-3 rounded-2xl border p-4 text-left transition-colors ${n.read ? "border-[#E5E0D8] bg-white" : "border-[#0D5C3A]/30 bg-[#F0ECE1]"}`}>
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-white text-[#0D5C3A]"><Icon className="h-5 w-5" /></div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <p className="font-semibold text-stone-900">{n.title}</p>
                    {!n.read && <Circle className="h-2 w-2 fill-[#C85A32] text-[#C85A32]" />}
                  </div>
                  <p className="text-sm text-stone-600">{n.message}</p>
                  <p className="mt-1 text-xs text-stone-400">{new Date(n.created_at).toLocaleString()}</p>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
